import React from "react";
import Responsive from "react-responsive";

export const LargerDesktop = props => <Responsive {...props} minWidth={1280} />;
export const LessLargerDesktop = props => <Responsive {...props} maxWidth={1279} />;
export const Desktop = props => <Responsive {...props} minWidth={992} />;
export const DesktopAndTablet = props => <Responsive {...props} minWidth={768} />;
export const MobileAndTablet = props => <Responsive {...props} maxWidth={991} />;
export const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={991} />;
export const Mobile = props => <Responsive {...props} maxWidth={767} />;